var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{ref:"pdfWrapper",staticClass:"file-wrapper-pdf"},[(_vm.pdf)?_c(_setup.Pdf,{staticClass:"file-wrapper-pdf-content"}):_c(_setup.PtNodata,{staticClass:"file-wrapper-pdf-nodata",attrs:{"nodataTips":_vm.nodataTips}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }